import React from "react";

import classes from "./styles.module.scss";
import { ModalBody } from "Components/ReactstrapSlim";
import CloseButton from "../../CloseButton";
import classNames from "classnames";

interface ModalBodyDemoProps {
   toggle(): void;
}

const ModalBodyDemo: React.FC<ModalBodyDemoProps> = ({ toggle }) => {
   return <ModalBody className={classes.modalBody}>
      <CloseButton toggle={toggle} />
      <div className={classes.header}>
         <div className={classes.header1}>Thank you!</div>
         <div className={classes.header2}>We’ll be in touch shortly.</div>
      </div>
      <div className={classes.card}>
         <div className={classes.cardCaption}>See LiquidSpace in action...</div>
         <div className={classes.cardTitle}>
            GoFundMe’s flexible workplace: 121 cities, 92% satisfaction.
         </div>
         <a className={classNames(classes.cta, "btn btn-primary btn-lg")} href="https://resources.liquidspace.com/inside-gofundme-flex-workplace-strategy" target="_blank">Read the case study</a>
      </div>
   </ModalBody>
}

export default ModalBodyDemo;